module.exports = __webpack_public_path__ + "img/组 1474@2x.ab5fecb1.png";